import React, { useEffect, useState } from "react";
import {
  NavLink,
  Outlet,
  useParams,
  useNavigate,
} from "react-router-dom";
import { fetchJobById } from "../../Redux/ActionCreators/jobsAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Stage4InviteCandidates from "../CreateJob/InviteCandidates";

const JobTabs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jobId } = useParams();

  const job = useSelector((state) => state.jobs.latestJob);

  const [showAddCandidates, setShowAddCandidates] = useState(false);
  const [titleLoading, setTitleLoading] = useState(false);

  useEffect(() => {
    const fetchJobData = async () => {
      if (jobId) {
        setTitleLoading(true);
        await dispatch(fetchJobById(jobId));
        setTitleLoading(false);
      }
    };
    fetchJobData();
  }, [dispatch, jobId]);

  return (
    <div className="job-tabs">
      <div className="job-navigation">
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <img
            src="/images/back-arrow-black.svg"
            alt=""
            onClick={() => navigate("/jobs")}
            style={{ cursor: "pointer" }}
          />
          {titleLoading ? (
            <div
              className="loading-overlay"
              style={{
                alignItems: "start",
                height: "auto",
                display: "flex",
                justifyContent: "start",
              }}
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading job...</span>
              </div>
            </div>
          ) : (
            <h3>{job ? job.title : ""}</h3>
          )}
        </div>
        <button
          className="add-candidate-btn"
          onClick={() => setShowAddCandidates(true)}
          disabled={showAddCandidates}
          style={showAddCandidates ? { cursor: "not-allowed", opacity: 0.5 } : {}}
        >
          Add Candidates
        </button>
      </div>
      <div className="tabs-header">
        <div className="d-flex tabs-items">
          <NavLink
            to={`/jobs/${jobId}/candidates`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Candidates
          </NavLink>
          <NavLink
            to={`/jobs/${jobId}/details`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Job Details
          </NavLink>
          <NavLink
            to={`/jobs/${jobId}/settings`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Job Settings
          </NavLink>
          <NavLink
            to={`/jobs/${jobId}/automation`}
            className="tab-btn"
            onClick={showAddCandidates ? (e) => e.preventDefault() : undefined}
            style={showAddCandidates ? { cursor: "not-allowed", pointerEvents: "all" } : {}}
          >
            Automation
          </NavLink>
        </div>
      </div>

      {/* Render Active Tab or Add Candidates panel */}
      <div className="tab-content">
        {showAddCandidates ? (
          <Stage4InviteCandidates
            jobId={jobId}
            fromJobTabs={true}
            onBack={() => setShowAddCandidates(false)}
          />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default JobTabs;
